<style lang="scss">
.page-sidebar {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 100%;
  h1 {
    margin: 0 20px 20px 20px;
    padding: 17px 0 17px 0;
    font-size: 18px;
    font-weight: bold;
    line-height: 24px;
    text-align: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
  ul,
  li {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  a {
    color: #fff;
    display: flex;
    align-items: center;
    padding: 12px 0 12px 20px;
    font-size: 16px;
    text-decoration: none;
    opacity: 0.6;
    position: relative;
    &.router-link-active {
      color: #fff;
      opacity: 1;
      &:before {
        position: absolute;
        right: 0;
        top: 50%;
        content: "";
        width: 1em;
        height: 1em;
        background: url("/sidebar-anchor.svg") no-repeat right center;
        transform: translateY(-50%);
      }
    }
    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
    svg {
      color: #fff;
    }
    img {
      margin-right: 0.5rem;
    }
  }
  .user-info {
    text-align: left;
    color: #fff;
    opacity: .8;
    padding: 1em;
  }
}
</style>

<template>
  <div class="page-sidebar">
    <div>
      <h1>
        <img src="@/assets/full-logo.svg" />
      </h1>
      <ul tars="id=46,selector=li">
        <li>
          <router-link to="/site">
            <img class="icon" src="@/assets/all-site.svg" />
            我的站点
          </router-link>
        </li>
        <li v-ui-permission="'setPermission'">
          <router-link to="/permission-manage">
            <img class="icon" src="@/assets/permission.svg" />
            系统设置
          </router-link>
        </li>
        <li>
          <router-link to="/js-sdk">
            <img class="icon" src="@/assets/js-sdk.svg" />
            接入文档
          </router-link>
        </li>
      </ul>
    </div>
    <div class="user-info">你好，{{userInfo.cn_name}}</div>
  </div>
</template>

<script>
export default {
  methods: {
    handleOpen () {},
    handleClose () {}
  },
  computed: {
    userInfo () {
      return this.$store.state.userInfo
    }
  }
}
</script>
